module.exports = __webpack_public_path__ + "public/images/no-general-pattern.5427d2290903c8243d1dfb21e1f9c3e5.svg";